import React, { Component } from "react";
import { connect } from "react-redux";
import SurveyGestion from "./../../components/survey/gestion/SurveyGestion";
import {
	setMenuLeftContent,
	setMenuLeftIndex,
	setMenuLeftItemIndex,
	setMenuTopIndex,
} from "../../redux/actions/menuActions";
import MenuActivite from "../activite/Menu";

class Gestion extends Component {
	componentDidMount() {
		this.props.setMenuTopIndex("activite");
		this.props.setMenuLeftContent(MenuActivite);
		this.props.setMenuLeftIndex("questionnaire");
		this.props.setMenuLeftItemIndex("surveyList");
	}
	render() {
		return <SurveyGestion {...this.props} />;
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		//currentSurvey: surveySelector(state, ownProps),
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		setMenuLeftIndex: index => {
			dispatch(setMenuLeftIndex(index));
		},
		setMenuLeftItemIndex: index => {
			dispatch(setMenuLeftItemIndex(index));
		},
		setMenuLeftContent: content => {
			dispatch(setMenuLeftContent(content));
		},
		setMenuTopIndex: index => {
			dispatch(setMenuTopIndex(index));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Gestion);



// WEBPACK FOOTER //
// src/pages/survey/Gestion.js